import axios from 'axios';
import { type APIResponse, type RetrieveAllParams } from '~/api/utils';
import { ComicBook, type IComicBook } from '~/types/ComicBook';

const API_URL = 'comic-book';

class ComicBookService {
    async createComicBook(comicBook: IComicBook): Promise<ComicBook> {
        return new ComicBook((await axios.post(`${API_URL}`, comicBook)).data);
    }

    async updateComicBook(id: string, updatedComics: Partial<ComicBook>): Promise<ComicBook> {
        const response = await axios.patch<ComicBook>(`${API_URL}/${id}`, updatedComics);
        return response.data;
    }

    async retrieveComicBookById(id: string): Promise<ComicBook> {
        return new ComicBook((await axios.get(`${API_URL}/${id}`))?.data);
    }

    async retrieveAllComicBooks(params?: RetrieveAllParams): Promise<APIResponse<ComicBook>> {
        const response = await axios.get(API_URL, {
            params: {
                ...params,
            },
        });

        return {
            content: response.data.content?.map((c: any) => new ComicBook(c)),
            page: {
                size: response.data.page?.size,
                number: response.data.page?.number,
                totalElements: response.data.page?.totalElements,
                totalPages: response.data.page?.totalPages,
            },
        };
    }

    async deleteComicBooks(id: string): Promise<ComicBook> {
        return new ComicBook(await axios.delete(`${API_URL}/${id}`));
    }
}

export default new ComicBookService();
